import { React, useEffect } from "react"
import { connect } from "react-redux"
import { useToast, Container, Flex } from "@chakra-ui/react"
import SEO from "../../components/SEO"

import SheetHeader from "../../components/SheetHeader"
import SheetRows from "../../components/SheetRows"
import SheetRowMove from "../../components/SheetRowMove"
import StatusTravel from "../../components/StatusTravel"
import SwitchDetails from "../../components/SwitchDetails"
import SheetSummary from "../../components/SheetSummary"

import nodeIsTopCalc from "../../functions/nodes/nodeIsTopCalc"
import nodeIsBottomCalc from "../../functions/nodes/nodeIsBottomCalc"

import { isFactoryResetUpdate } from "../../redux/actions/app"
import { messageFromProjectDelete } from "../../redux/actions/project"
import { messageFromAppDelete } from "../../redux/actions/app"

const PageControlSheet = ({
  project,
  messageFromProject,
  isDebugOn,
  messageFromApp,
  isFactoryReset,
  dispatch,
}) => {
  //=================================================================
  const { params, statusCurrent } = project
  const { nodes, nodeActive } = project.statuses[statusCurrent]
  const { isStatusLocked } = project.statuses[statusCurrent].setup

  let node = null
  let isTop = false
  let isBottom = false

  if (!isStatusLocked && nodeActive !== "") {
    node = nodes[nodeActive]
    isTop = nodeIsTopCalc(nodes, node.nId)
    isBottom = nodeIsBottomCalc(nodes, node.nId)
  }

  const toast = useToast()

  useEffect(() => {
    if (messageFromProject !== "") {
      const title = messageFromProject.split(": ")[0]
      const description = messageFromProject.substring(
        messageFromProject.indexOf(":") + 1
      )
      const status = title.toLowerCase()
      toast({
        title,
        description,
        status: status ? status : "info",
        duration: 9000,
        isClosable: true,
      })
      dispatch(messageFromProjectDelete())
    }
    if (messageFromApp !== "") {
      const title = messageFromApp.split(": ")[0]
      const description = messageFromApp.substring(
        messageFromApp.indexOf(":") + 1
      )
      toast({
        title,
        description,
        status: "error",
        duration: isDebugOn ? 100 : 30000,
        isClosable: true,
      })
      dispatch(messageFromAppDelete())
    }
  }, [messageFromProject, messageFromApp, toast, isDebugOn, dispatch])

  useEffect(() => {
    if (isFactoryReset) {
      const payload = { isFactoryReset: false }
      dispatch(isFactoryResetUpdate(payload))
      window.location.reload()
    }
  }, [isFactoryReset, dispatch])

  //=================================================================
  return (
    // <Container maxW="1600px" px={0} minH="640px">
    <Container px={0} minH="640px">
      <SEO
        title="Status Sheet | THE PROJECT STATUS"
        urlPage="/"
        description="Replace any spreadsheet with a status report that is supporting proper project control."
      ></SEO>
      <SheetSummary />
      <StatusTravel />
      <Flex
        justify="space-between"
        flexDirection="row-reverse"
        wrap="wrap"
        w="100%"
        pr={2}
      >
        <SwitchDetails />
        {!isStatusLocked && nodeActive !== "" && (
          <SheetRowMove
            node={node}
            isTop={isTop}
            isBottom={isBottom}
            dispatch={dispatch}
          />
        )}
      </Flex>
      <SheetHeader params={params} />
      <SheetRows />
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    project: state.project,
    messageFromApp: state.app.messageFromApp,
    isDebugOn: state.app.isDebugOn,
    messageFromProject: state.project.messageFromProject,
    isResetForm: state.project.isResetForm,
    isFactoryReset: state.settings.isFactoryReset,
  }
}

export default connect(mapStateToProps)(PageControlSheet)
